// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Tq","link":"e_Uq","imageContainer":"e_Vq","author":"e_Wq","text":"e_Xq","buttonIcon":"e_Yq"};